import React from 'react';
import { bool, func, number, object } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { logger } from '@fiverr-private/perseus';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { getPackageById, isRecurringGig, isTriplePackage } from '../../../reducers/packages';
import { isVoiceOver } from '../../../utils/packagesUtils';
import PackageContent from '../../shared/PackageContent';
import TabFooter from './TabFooter';

import './style.scss';

const Content = ({
    id,
    currentPrice,
    inProgress,
    showCompareAnchor,
    onComparePackagesClick,
    isRecurringGig = false
}, { general }) => {

    const { isLimitedEdition } = general;

    // TODO: remove when VO package has a title
    const title = isVoiceOver(general) ? 'gig_page_perseus.packages.order_details' : '';

    const wrapperClass = classNames(
        'content',
        { 'recurring-gig': isRecurringGig }
    );

    return (
        <div className={wrapperClass}>
            <PackageContent id={id} showPrice={!isLimitedEdition} title={title ? <I18n k={title}/> : ''}/>
            <TabFooter showCompareAnchor={showCompareAnchor} inProgress={inProgress}
                currentPrice={currentPrice} onComparePackagesClick={onComparePackagesClick}/>
        </div>
    );
};

Content.propTypes = {
    id: number,
    currentPrice: number,
    inProgress: bool,
    onComparePackagesClick: func,
    showCompareAnchor: bool,
    isRecurringGig: bool
};

Content.contextTypes = {
    general: object
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.id);
    const triplePackage = isTriplePackage(packages);

    if (!packageData.title) {
        const { url } = getContext();
        logger.warn({
            message: 'missing package title',
            url,
            is_triple_package: triplePackage
        });
    }

    return {
        ...packageData,
        onComparePackagesClick: ownProps.onComparePackagesClick,
        isRecurringGig: isRecurringGig(packages)
    };
};

const ContentConnect = connect(mapStateToProps)(Content);

const TabContent = ({ id, onComparePackagesClick, showCompareAnchor }) => (
    <ContentConnect id={id}
        onComparePackagesClick={onComparePackagesClick}
        showCompareAnchor={showCompareAnchor}/>
);

export { Content };
export default TabContent;
